import { ThemeContext } from "@fluentui/react-theme-provider";
import React, { useContext } from "react";
import Auth from "../../Auth/Auth";
import { serverHost } from "../../config";
import ElementsIAIcon from "../../images/ia.svg";
import ElementService, { ElementContractInfo, ElementIARefundValidationRequest, ElementIARefundValidationResponse } from "../../services/ElementsService";
import * as IA from "./ElementStyles"; 
import { IStackTokens, ITextFieldStyles, Separator, Spinner, SpinnerSize, Stack, TextField, TeachingBubble, Icon, Modal, PrimaryButton, DefaultButton } from "@fluentui/react";
import { useForm } from "react-hook-form";
import { SignatureComponent } from "../../components/Signature/SignatureComponent";
import scrollToTop from "../../utils/scrollToTop";
import SignaturesService, { ISignature } from "../../services/SignaturesService";
import DocumentTitle from "react-document-title";
import { useHistory } from "react-router";
import moment from "moment";
import ModalElementsIATransfer from "./ModalElementsIATransfer";
import UserIdentitiesService from "../../services/UserIdentitiesService";
import { useId } from "@fluentui/react-hooks";
import { ModalRefund } from "../Refunds/components/ModalRefund";
import users from "../../services/UserService";
import { AccountsAutorized } from "../../services/SubscriptionService";
import { Accounts } from "../Refunds/Refunds";
import DropdownAccounts from "../Refunds/components/DropdownAccounts";
import UserService from "../../services/UserService";
import { isValidRefundCode, getRefundCodeErrorMessage as getRefundCodeError } from "../../utils/RefundCodeValidation";

interface SavingsPlanRefund
{
    planId: number;
    planName: string;
    elementAmount: number;
    hasContractSigned: boolean;
    selectedAccount: string;
    amount: string;
    isValid: boolean;
}

const ElementsIATransfer = () =>
{
    const horizontalGapStackTokens: IStackTokens =
    {
        childrenGap: 10,
    };
    const inputId = useId();
    const history = useHistory();
    const theme = useContext(ThemeContext);
    const stylesPassword: Partial<ITextFieldStyles> = {};
    const subscribed = Auth.isSubscribed();
    const user = Auth.getUserProfile();
    const {register} = useForm({mode: "onChange"});
    const [signatures, setSignatures] = React.useState<ISignature[]>([]);
    const [getSignature, setSignature] = React.useState<boolean>(false);
    const [showSignature, setShowSignature] = React.useState<boolean>(false);
    const [isSignatureShowed, setIsSignatureShowed] = React.useState<boolean>(false);
    const [modalOKShow, setModalOKShow] = React.useState<boolean>(false);
    const [modalKOShow, setModalKOShow] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState("");
    const firstTime = React.useRef<boolean>(true);
    const [refundCode, setRefundCode] = React.useState<any>("");
    const [accounts, setAccounts] = React.useState<Accounts[]>([]);
    const [loading, setLoading] = React.useState<boolean>(true);
    const [processingLoading, setProcessingLoading] = React.useState<boolean>(false);
    const [elementContracts, setElementContracts] = React.useState<ElementContractInfo[]>([]);
    const [contractsLoading, setContractsLoading] = React.useState<boolean>(true);
    const [savingsPlanRefunds, setSavingsPlanRefunds] = React.useState<SavingsPlanRefund[]>([]);
    const [showPassword, setShowPassword] = React.useState<boolean>(false);
    const [showTeachingBubbles, setShowTeachingBubbles] = React.useState<{[key: number]: boolean}>({});
    const [refundCodeValue, setRefundCodeValue] = React.useState<string>("");
    const [showValidationModal, setShowValidationModal] = React.useState<boolean>(false);
    const [validationResult, setValidationResult] = React.useState<any>(null);

    const checkElementsContractByAllSavingPlans = async () =>
    {
        try
        {
            const response = await ElementService.checkElementsContractByAllSavingPlans();
            setElementContracts(response);
            
            // Procesar los contratos para crear el estado de reembolsos
            const refunds: SavingsPlanRefund[] = response.map((contract: ElementContractInfo) =>
            {
                const elementAmount = Number(contract.elementsIA) || 0;
                
                const refund =
                {
                    planId: contract.savingsPlanId,
                    planName: contract.savingsPlanName,
                    elementAmount: elementAmount,
                    hasContractSigned: contract.hasLatestVersionSigned,
                    selectedAccount: "",
                    amount: "",
                    isValid: false
                };

                return refund;
            });
            
            setSavingsPlanRefunds(refunds);
            setContractsLoading(false);
        }
        catch(error)
        {
            console.error("Error al obtener contratos de Elements por planes de ahorro:", error);
            setContractsLoading(false);
        }
    };

    const checkRefundCode = async (usrId: any) =>
    {
        const refund = await UserIdentitiesService.isRefundCodeDefined(user.mainUserIdentity.id).catch((error: any) => {});

        if(!!refund === refund)
        {
            firstTime.current = false;
            setLoading(false);
            if(refund === true)
            {
                setRefundCode("claveReembolso");
            }
        }
    };

    const checkDefaultIBAN = async (userId: any) =>
    {
        if(userId > 0)
        {
            users.getBankAccountsAutorized(userId).then((response: AccountsAutorized[]) =>
            {
                if(response !== null && response.length > 0)
                {
                    let accounts: Accounts[] = [];
                    let seenIBANs = new Set<string>(); // Para evitar IBANs duplicados
                    
                    for(let i=0; i<response.length; i++)
                    {
                        const iban = response[i].accountOrigin;
                        
                        // Solo añadir si el IBAN no ha sido visto antes
                        if(!seenIBANs.has(iban))
                        {
                            seenIBANs.add(iban);
                            accounts.push(
                            {
                                id: response[i].id as number,
                                value: iban,
                                default: response[i].isSelected
                            });
                        }

                    }
                    
                    setAccounts(accounts);
                }
            });
        }
    }

    // Función para actualizar la cuenta seleccionada de un plan específico
    const updatePlanAccount = React.useCallback((planId: number, account: string) =>
    {
        setSavingsPlanRefunds(prevRefunds => prevRefunds.map(refund => 
        {
            if(refund.planId === planId)
            {
                const updatedRefund = {...refund, selectedAccount: account};
                const isValid = updatedRefund.selectedAccount !== "" && 
                                updatedRefund.amount !== "" && 
                                !isNaN(parseFloat(updatedRefund.amount)) &&
                                parseFloat(updatedRefund.amount) >= 1000 &&
                                updatedRefund.hasContractSigned;
                return {...updatedRefund, isValid};
            }
            return refund;
        }));
    }, []);

    // Función para auto-seleccionar cuenta si solo hay una opción disponible
    const autoSelectSingleAccount = React.useCallback((planId: number) =>
    {
        if(accounts.length === 1)
        {
            const singleAccount = accounts[0];
            
            setSavingsPlanRefunds(prevRefunds => prevRefunds.map(refund => 
            {
                if(refund.planId === planId)
                {
                    const updatedRefund = {...refund, selectedAccount: singleAccount.value};
                    const isValid = updatedRefund.selectedAccount !== "" && 
                                    updatedRefund.amount !== "" && 
                                    !isNaN(parseFloat(updatedRefund.amount)) &&
                                    parseFloat(updatedRefund.amount) >= 1000 &&
                                    updatedRefund.hasContractSigned;
                    return {...updatedRefund, isValid};
                }
                return refund;
            }));
        }
    }, [accounts]);

    // Función para actualizar el importe de un plan específico
    const updatePlanAmount = React.useCallback((planId: number, amount: string) =>
    {
        setSavingsPlanRefunds(prevRefunds => prevRefunds.map(refund => 
        {
            if(refund.planId === planId)
            {
                const updatedRefund = {...refund, amount: amount};
                const isValid = updatedRefund.selectedAccount !== "" && 
                                updatedRefund.amount !== "" && 
                                !isNaN(parseFloat(updatedRefund.amount)) &&
                                parseFloat(updatedRefund.amount) >= 1000 &&
                                updatedRefund.hasContractSigned;
                return {...updatedRefund, isValid};
            }
            return refund;
        }));
    }, []);

    // Función para manejar el click del botón de firmar contrato
    const handleSignContract = React.useCallback((planId: number) =>
    {
        //Hay que cambiar el plan activo al plan que recibimos porque si no el contrato a firmar no sería correcto.
        UserService.selectActivePlan(user.id, planId).then((response: any) =>
        {
            if(response === true)
            {
                history.push('/Elements/Signature');
            }
        });
    }, [history, user.id]);

    const showTeachingBubble = React.useCallback((index: number) =>
    {
        setShowTeachingBubbles(prev => ({...prev, [index]: true}));
    }, []);

    const hideTeachingBubble = React.useCallback((index: number) =>
    {
        setShowTeachingBubbles(prev => ({...prev, [index]: false}));
    }, []);

    const handleRemovePlan = React.useCallback((planId: number) =>
    {
        setSavingsPlanRefunds(prevRefunds => prevRefunds.filter(refund => refund.planId !== planId));
    }, []);

    React.useEffect(() =>
    {
        if(firstTime.current === true)
        {
            checkElementsContractByAllSavingPlans();
            checkRefundCode(user.id);
            checkDefaultIBAN(user.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() =>
    {
        scrollToTop();
    }, []);

    // Auto-seleccionar cuentas únicas cuando se cargan los accounts
    React.useEffect(() =>
    {
        if(accounts.length === 1 && savingsPlanRefunds.length > 0)
        {
            savingsPlanRefunds.forEach(refund => 
            {
                if(refund.selectedAccount === "")
                {
                    autoSelectSingleAccount(refund.planId);
                }
            });
        }
    }, [accounts, savingsPlanRefunds, autoSelectSingleAccount]);


    React.useEffect(() =>
    {
        if(getSignature === true && signatures.length === 0)
        {
            SignaturesService.createSignatureNoPlan(user.id).then((response: any) =>
            {
                if(response.data.id !== null)
                {
                    setSignatures([response.data]);
                    setIsSignatureShowed(true);
                    setShowSignature(true);
                }
            });
        }
    }, [signatures, user.id, getSignature]);

    const processExpirationDate = (signs: ISignature[]) =>
    {
        if(signs !== undefined && signs.length > 0)
        {
            // eslint-disable-next-line array-callback-return
            signs.map((signature: ISignature) =>
            {
                if(signature && typeof signature.expiresAt === "string")
                {
                    signature.expiresAt = moment(signature.expiresAt).toDate();
                }
            });
        }
    }

    const onChangeError = React.useCallback((value?: string) =>
    {
        let newVal = value === undefined ? "" : value;
        setErrorMessage(newVal);
    }, []);

    const handleSubmit = () =>
    {   
        // Obtener solo los planes de ahorro reembolsables y válidos
        const validRefunds = savingsPlanRefunds.filter(refund => refund.elementAmount > 0 && refund.isValid);

        if(validRefunds.length === 0)
        {
            onChangeError("No hay planes de ahorro reembolsables válidos para reembolsar.");
            return;
        }

        // Crear array de reembolsos para enviar al backend
        const refundsData = validRefunds.map(refund =>
        ({
            userId: user.id,
            savingsPlanId: refund.planId,
            IBAN: refund.selectedAccount,
            signatureId: signatures[0].id,
            amount: parseFloat(refund.amount),
            refundCode: refundCodeValue
        }));

        // Enviar todos los reembolsos en una sola llamada al backend
        ElementService.transferElementsIA(refundsData).then((response: any) =>
        {
            if(response.status === true)
            {
                setModalOKShow(true);
                setProcessingLoading(false);
            }
            else
            {
                setModalKOShow(true);
                setProcessingLoading(false);
            }
        }).catch((error) =>
        {
            console.error("Error al procesar reembolsos:", error);
            setErrorMessage("Error inesperado al procesar los reembolsos");
            setModalKOShow(true);
            setProcessingLoading(false);
        });
    };

    const handleShow = () =>
    {
        setProcessingLoading(true);
        
        // Realizar validación completa
        const validation = validateRefunds();
        
        // Guardar resultado de validación
        setValidationResult(validation);
        
        // Mostrar modal de validación
        setShowValidationModal(true);
        // No resetear processingLoading aquí, se mantendrá hasta el modal final
    };

    const handleRefund: any = (event: any, item: any) =>
    {
        setRefundCode(item);
        setRefundCodeValue(item);
    };

    // Función para resetear todos los estados cuando falla el reembolso
    const resetStatesAfterError = React.useCallback(() =>
    {
        // Resetear estados de firma
        setSignature(false);
        setShowSignature(false);
        setIsSignatureShowed(false);
        
        // Resetear estados de procesamiento
        setProcessingLoading(false);
        setShowValidationModal(false);
        setValidationResult(null);
        
        // Resetear estados de modales
        setModalOKShow(false);
        setModalKOShow(false);
        setErrorMessage("");
        
        // Resetear estados de planes de ahorro para permitir nueva operación
        setSavingsPlanRefunds(prevPlans => prevPlans.map(plan =>
        ({
            ...plan,
            amount: "",
            selectedAccount: "",
            hasContractSigned: false,
            isValid: false
        })));
        
        // Resetear clave de reembolso
        setRefundCodeValue("");
        setRefundCode("");
    }, []);

    // Función para proceder con los reembolsos después de validación exitosa
    const proceedWithRefunds = React.useCallback(async (validPlans: SavingsPlanRefund[]) =>
    {
        setProcessingLoading(true);
        
        try
        {
            // Primera llamada: Validar reembolsos en el servidor
            const validationRequest: ElementIARefundValidationRequest =
            {
                refundItems: validPlans.map(plan =>
                ({
                    savingsPlanId: plan.planId,
                    amount: parseFloat(plan.amount),
                    refundCode: refundCodeValue,
                    bankAccounts: [plan.selectedAccount]
                }))
            };

            const serverValidation: ElementIARefundValidationResponse[] = await ElementService.validateElementIARefunds(validationRequest);
            
            // Verificar si todos los planes son válidos según el servidor
            const allValid = serverValidation.every(response => response.isValid);
            
            if(allValid)
            {
                // Segunda llamada: Proceder con la firma
                setSignature(true);
                // No resetear processingLoading aquí, se mantendrá hasta el modal final
            }
            else
            {
                // Mostrar errores del servidor
                const serverErrors: string[] = [];
                const invalidServerPlans: {plan: SavingsPlanRefund, errors: string[]}[] = [];
                
                serverValidation.forEach(response =>
                {
                    if(!response.isValid && response.errorMessages.length > 0)
                    {
                        const plan = validPlans.find(p => p.planId === response.savingsPlanId);
                        if(plan)
                        {
                            invalidServerPlans.push(
                            {
                                plan: plan,
                                errors: response.errorMessages
                            });
                        }
                        else
                        {
                            serverErrors.push(`${response.savingsPlanName}: ${response.errorMessages.join(', ')}`);
                        }
                    }
                });

                // Actualizar resultado de validación con errores del servidor
                const updatedValidation =
                {
                    validPlans: validPlans.filter(plan => serverValidation.find(response => response.savingsPlanId === plan.planId)?.isValid),
                    invalidPlans: invalidServerPlans,
                    generalErrors: serverErrors,
                    isValid: false
                };

                setValidationResult(updatedValidation);
                setShowValidationModal(true);
                // No resetear processingLoading aquí, se mantendrá hasta el modal final
            }
        }
        catch(error)
        {
            console.error("Error al proceder con reembolsos:", error);
            setErrorMessage("Error inesperado al procesar los reembolsos");
            setModalKOShow(true);
            setProcessingLoading(false);
        }
    }, [refundCodeValue]);

    // Verificar si todos los planes de ahorro reembolsables tienen importe relleno y contrato firmado
    const areAllVisibleRefundsReady = React.useCallback(() =>
    {
        if(!savingsPlanRefunds || savingsPlanRefunds.length === 0)
        {
            return false;
        }
        
        // Filtrar solo los planes que son reembolsables (Elements IA > 0)
        const refundablePlans = savingsPlanRefunds.filter(refund => refund.elementAmount > 0);
        
        // Si no hay planes reembolsables, no se puede activar el botón
        if(refundablePlans.length === 0)
        {
            return false;
        }
        
        // Verificar que todos los planes reembolsables tengan importe relleno y contrato firmado
        return refundablePlans.every(refund => 
            refund.amount !== "" && 
            !isNaN(parseFloat(refund.amount)) &&
            parseFloat(refund.amount) >= 1000 &&
            refund.hasContractSigned
        );
    }, [savingsPlanRefunds]);


    // Verificar si la clave de reembolso está rellena y es válida
    const isRefundCodeFilled = React.useCallback(() =>
    {
        if(!refundCodeValue || refundCodeValue.trim() === "")
        {
            return false;
        }
        
        return isValidRefundCode(refundCodeValue);
    }, [refundCodeValue]);

    // Obtener mensaje de error para la clave de reembolso
    const getRefundCodeErrorMessage = React.useCallback(() =>
    {
        return getRefundCodeError(refundCodeValue);
    }, [refundCodeValue]);

    // Verificar si hay IBANs disponibles
    const areIBANsAvailable = React.useCallback(() =>
    {
        return accounts && accounts.length > 0;
    }, [accounts]);

    // Función de validación completa que retorna planes válidos y errores
    const validateRefunds = React.useCallback(() =>
    {
        const errors: string[] = [];
        const validPlans: SavingsPlanRefund[] = [];
        const invalidPlans: {plan: SavingsPlanRefund, errors: string[]}[] = [];

        // Validar que haya planes de ahorro disponibles
        if(!savingsPlanRefunds || savingsPlanRefunds.length === 0)
        {
            errors.push("No hay planes de ahorro disponibles para reembolsar.");
            return { validPlans, invalidPlans, generalErrors: errors, isValid: false };
        }

        // Validar que haya IBANs disponibles
        if(!accounts || accounts.length === 0)
        {
            errors.push("No hay cuentas bancarias disponibles para realizar el reembolso.");
            return { validPlans, invalidPlans, generalErrors: errors, isValid: false };
        }

        // Validar que la clave de reembolso esté rellena y sea base64 válida
        if(!refundCodeValue || refundCodeValue.trim() === "")
        {
            errors.push("Debe indicar la clave de reembolso.");
            return { validPlans, invalidPlans, generalErrors: errors, isValid: false };
        }

        if(!isValidRefundCode(refundCodeValue))
        {
            errors.push("La clave de reembolso debe cumplir con los requisitos de seguridad: 12-30 caracteres con mayúscula, minúscula, número y carácter especial.");
            return { validPlans, invalidPlans, generalErrors: errors, isValid: false };
        }

        // Filtrar solo los planes reembolsables (Elements IA > 0)
        const refundablePlans = savingsPlanRefunds.filter(refund => refund.elementAmount > 0);
        
        if(refundablePlans.length === 0)
        {
            errors.push("No hay planes de ahorro reembolsables disponibles (Elements IA > 0).");
            return { validPlans, invalidPlans, generalErrors: errors, isValid: false };
        }

        // Validar cada plan reembolsable
        refundablePlans.forEach(plan =>
        {
            const planErrors: string[] = [];

            // Validar contrato firmado
            if(!plan.hasContractSigned)
            {
                planErrors.push("El contrato no está firmado");
            }

            // Validar importe
            if(!plan.amount || plan.amount.trim() === "")
            {
                planErrors.push("El importe no está relleno");
            }
            else if(isNaN(parseFloat(plan.amount)))
            {
                planErrors.push("El importe no es un número válido");
            }
            else if(parseFloat(plan.amount) < 1000)
            {
                planErrors.push("El importe debe ser de al menos 1000 Elements IA");
            }
            else if(parseFloat(plan.amount) > plan.elementAmount)
            {
                planErrors.push(`El importe no puede ser mayor a los Elements IA disponibles (${plan.elementAmount})`);
            }

            // Validar cuenta seleccionada
            if(!plan.selectedAccount || plan.selectedAccount.trim() === "")
            {
                planErrors.push("No se ha seleccionado una cuenta bancaria");
            }

            if(planErrors.length === 0)
            {
                validPlans.push(plan);
            }
            else
            {
                invalidPlans.push({ plan, errors: planErrors });
            }
        });

        const isValid = errors.length === 0 && invalidPlans.length === 0 && validPlans.length > 0;

        return { validPlans, invalidPlans, generalErrors: errors, isValid };
    }, [savingsPlanRefunds, accounts, refundCodeValue]);

    if(subscribed === false)
    {
        localStorage.clear();
        window.location.href = serverHost + '/login';
        return (<></>);
    }

    return(
        <DocumentTitle title='IronIA - Reembolso de ElementsIA'>
            <IA.IATransferMain theme={theme}>
                <IA.IATitleContainer>
                    <h2>Transferencia Elements IA</h2>
                </IA.IATitleContainer>
                <IA.IASeparatorTop />
                <div className="ms-Grid restarted-ms-Grid">
                    {(loading || contractsLoading) &&
                    (
                        <React.Fragment>
                            <Spinner size={SpinnerSize.large} />
                        </React.Fragment>
                    )}
                    {loading === false && contractsLoading === false &&
                    (
                        <React.Fragment>
                            {elementContracts.length === 0 ?
                            (
                                <IA.IATransferMain>
                                    <IA.IAInfoForm theme={theme}>
                                        <IA.IACard theme={theme}>
                                            <IA.IACardTitle theme={theme}>
                                                <IA.IATitleCardText theme={theme}>
                                                    Información importante de las Transferencias de Elements IA
                                                </IA.IATitleCardText>
                                            </IA.IACardTitle>
                                            <IA.IACardBody>
                                                <IA.IAText theme={theme}>
                                                    Puedes reembolsar tantos Elements IA como poseas en cada Plan de Ahorro en IronIA, siempre y cuando la cantidad sea de un mínimo de 1000 Elements IA por cada transferencia y que tengas firmada la última versión del contrato de Elements correspondiente a cada uno de esos Planes de Ahorro.
                                                    <br />
                                                    <br />
                                                    La transferencia del importe se realizará mediante transferencia SEPA a una cuenta corriente previamente
                                                    autorizada en la que hayamos verificado previamente tu titularidad para cumplir con la normativa antibloqueo
                                                    de capitales y financiación del terrorismo.
                                                    <br />
                                                    <br />
                                                    Nota: Esta transferencia no es inmediata desde que se cursa y valida la petición de transferencia.
                                                </IA.IAText>
                                            </IA.IACardBody>
                                        </IA.IACard>
                                    </IA.IAInfoForm>
                                    <IA.IATransferForm theme={theme}>
                                    <IA.IACardContainer theme={theme}>
                                        <IA.IACardHeader>
                                            <IA.IACardHeadingContainer>
                                                        <h3>No hay planes de ahorro con contrato de Elements</h3>
                                            </IA.IACardHeadingContainer>
                                            <Separator />
                                        </IA.IACardHeader>
                                        <IA.IACardBody>
                                                <IA.IAText theme={theme}>
                                                    No se encontraron planes de ahorro con contrato de Elements disponibles para realizar transferencias.
                                                </IA.IAText>
                                            </IA.IACardBody>
                                        </IA.IACardContainer>
                                    </IA.IATransferForm>
                                </IA.IATransferMain>
                            ) :
                            (
                                <IA.IATransferMain>
                                    <IA.IAInfoForm theme={theme}>
                                        <IA.IACard theme={theme}>
                                            <IA.IACardTitle theme={theme}>
                                                <IA.IATitleCardText theme={theme}>
                                                    Información de las Transferencias de Elements IA
                                                </IA.IATitleCardText>
                                            </IA.IACardTitle>
                                            <IA.IACardBody>
                                                <IA.IAText theme={theme}>
                                                    Puedes reembolsar tantos Elements IA como poseas en cada Plan de Ahorro en IronIA, siempre y cuando la cantidad sea de un mínimo de 1000 Elements IA por cada transferencia y que tengas firmada la última versión del contrato de Elements correspondiente a cada uno de esos Planes de Ahorro.
                                                    <br />
                                                    <br />
                                                    La transferencia del importe se realizará mediante transferencia SEPA a una cuenta corriente previamente
                                                    autorizada en la que hayamos verificado previamente tu titularidad para cumplir con la normativa antibloqueo
                                                    de capitales y financiación del terrorismo.
                                                    <br />
                                                    <br />
                                                    Nota: Esta transferencia no es inmediata desde que se cursa y valida la petición de transferencia.
                                                </IA.IAText>
                                            </IA.IACardBody>
                                        </IA.IACard>
                                    </IA.IAInfoForm>
                                    <IA.IATransferForm theme={theme}>
                                        <IA.IACardContainer theme={theme}>
                                            <IA.IACardHeader>
                                                <IA.IACardHeadingContainer>
                                                    <h3>Reembolso de Elements IA mediante transferencia SEPA no inmediata</h3>
                                                </IA.IACardHeadingContainer>
                                                <IA.IACustomSeparator />
                                            </IA.IACardHeader>
                                            <IA.IACardBody>
                                                <IA.IAInformText theme={theme}>
                                                    <IA.IAAdvertisedText theme={theme}>
                                                        Aquí se listan todos los Planes de Ahorro que tienes en IronIA con un Contrato de Elements firmado en vigor para que selecciones 
                                                        de cuales quieres reembolsar los Elements IA.
                                                        <br />
                                                        <br />
                                                        Cada reembolso se procesará por separado, con una orden y una firma independiente para cada uno.
                                                        <br />
                                                        <br />
                                                        La clave de reembolso es común a todos los reembolsos.
                                                        <br />
                                                        <br />
                                                        Descarta con la cruz arriba a la derecha cada Plan de Ahorro que no quieras reembolsar. Al pulsar en el botón Firmar Reembolsos, se procesarán
                                                        las órdenes de transferencia de todos los planes de ahorro que aparezcan en la pantalla y tengan el importe relleno.
                                                        <br />
                                                        <br />
                                                        El botón de Firmar Reembolsos sólo se activará cuando todos los planes de ahorro presentes tengan el importe relleno y el contrato firmado.
                                                    </IA.IAAdvertisedText>
                                                </IA.IAInformText>
                                                {refundCode === "" &&
                                                (
                                                    <React.Fragment>
                                                        <Stack horizontal tokens={horizontalGapStackTokens}>
                                                            <Stack.Item order={1} style={{width:"75%"}}>
                                                                <TextField styles={stylesPassword}
                                                                    disabled={true}
                                                                    canRevealPassword={true}
                                                                    type={"password"}
                                                                    autoComplete="off"
                                                                    required={true}
                                                                    label={"Clave de Reembolso"}
                                                                    placeholder={"Escribe aquí la Clave de Reembolso"}
                                                                    errorMessage={getRefundCodeErrorMessage()}
                                                                />
                                                            </Stack.Item>
                                                            <Stack.Item order={2} style={{width:"25%"}}>
                                                                <ModalRefund onChange={handleRefund} />
                                                            </Stack.Item>
                                                        </Stack>
                                                    </React.Fragment>
                                                )}
                                                {refundCode !== "" &&
                                                (
                                                    <React.Fragment>
                                                        <Stack>
                                                            <Stack.Item>
                                                                <IA.IARefundTextContainer>
                                                                    <TextField {...register("clave", {required: true})}
                                                                        type={showPassword ? "text" : "password"}
                                                                        id={inputId}
                                                                        autoComplete="off"
                                                                        required={true}
                                                                        label={"Clave de Reembolso"}
                                                                        placeholder={"Escribe aquí la Clave de Reembolso"}
                                                                        onChange={(event, newValue) => setRefundCodeValue(newValue || "")}
                                                                        errorMessage={getRefundCodeErrorMessage()}
                                                                        styles=
                                                                        {{
                                                                            fieldGroup:
                                                                            {
                                                                                paddingRight: "40px"
                                                                            },
                                                                            wrapper:
                                                                            {
                                                                                position: "relative"
                                                                            }
                                                                        }}
                                                                    />
                                                                    <IA.IARefundButtonReveal type="button" onClick={() => setShowPassword(!showPassword)}
                                                                        theme={theme} title={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                                                                    >
                                                                        {showPassword ? "✓" : "👁️"}
                                                                    </IA.IARefundButtonReveal>
                                                                </IA.IARefundTextContainer>
                                                            </Stack.Item>
                                                        </Stack>
                                                    </React.Fragment>
                                                )}
                                                <IA.IACustomSeparator />
                                                <IA.IASavingPlansTitle theme={theme}>
                                                    Listado de Planes de Ahorro con Contrato de Elements
                                                </IA.IASavingPlansTitle>
                                                {processingLoading ?
                                                (
                                                    <IA.IAProcessingStateContainer>
                                                        <Spinner size={SpinnerSize.large} />
                                                        <IA.IAProcessingStateText theme={theme}>
                                                            Realizando validaciones y proceso de reembolso
                                                        </IA.IAProcessingStateText>
                                                        <IA.IAProcessingStateSubText theme={theme}>
                                                            Por favor, espera mientras procesamos tu solicitud...
                                                        </IA.IAProcessingStateSubText>
                                                    </IA.IAProcessingStateContainer>
                                                ) : savingsPlanRefunds && savingsPlanRefunds.length > 0 ? savingsPlanRefunds.map((refund, index) =>
                                                {
                                                    const hasElementsIA = refund.elementAmount > 0;
                                                    const canOperate = hasElementsIA && refund.hasContractSigned;
                                                    
                                                    return(
                                                        <IA.IASavingPlanContainer key={refund.planId} theme={theme}
                                                            hasContractSigned={refund.hasContractSigned}
                                                            elementAmount={refund.elementAmount}
                                                        >
                                                            <IA.IASavingPlanCard>
                                                                <IA.IASavingPlanHeader>
                                                                    <IA.IASavingPlanNameContainer>
                                                                        <IA.IASavingPlanName theme={theme} hasContractSigned={refund.hasContractSigned} elementAmount={refund.elementAmount}>
                                                                            {refund.planName || "Sin nombre"}
                                                                        </IA.IASavingPlanName>
                                                                    </IA.IASavingPlanNameContainer>
                                                                    <IA.IASavingPlanContractStatusContainer>
                                                                        {refund.hasContractSigned ?
                                                                        (
                                                                            <IA.IASavingPlanRemoveButton theme={theme} onClick={() => handleRemovePlan(refund.planId)}>
                                                                                <Icon iconName="Cancel" />
                                                                            </IA.IASavingPlanRemoveButton>
                                                                        ) :
                                                                        (
                                                                            <IA.IASavingPlanContractStatus>
                                                                                <IA.IASavingPlanContractNotSigned>
                                                                                    ⚠ Contrato no firmado
                                                                                </IA.IASavingPlanContractNotSigned>
                                                                            </IA.IASavingPlanContractStatus>
                                                                        )}
                                                                    </IA.IASavingPlanContractStatusContainer>
                                                                </IA.IASavingPlanHeader>
                                                                <IA.IASavingPlanAccountsRow>
                                                                    <IA.IASavingPlanDropdownContainer>
                                                                        <DropdownAccounts accounts={accounts} alignment={'end'} paddingTop={'1.9rem'}
                                                                            dropdownChange={(newValue: string) => updatePlanAccount(refund.planId, newValue)} 
                                                                            errorMessage={refund.selectedAccount === "" && accounts.length > 1 ? "Seleccione una cuenta" : ""} 
                                                                            disabled={!canOperate}
                                                                        />
                                                                    </IA.IASavingPlanDropdownContainer>
                                                                </IA.IASavingPlanAccountsRow>
                                                                <IA.IASavingPlanAmountRow>
                                                                    <IA.IASavingPlanAmountLeft>
                                                                        <IA.IASavingPlanElementsInfo theme={theme} hasContractSigned={refund.hasContractSigned} elementAmount={refund.elementAmount}>
                                                                            Elements IA totales: {refund.elementAmount ? refund.elementAmount.toLocaleString() : "0"}
                                                                            <IA.IASavingPlanElementsIcon theme={theme}>
                                                                                <IA.IAElementsIAIcon alt="IA" src={ElementsIAIcon} width={"20px"}  />
                                                                            </IA.IASavingPlanElementsIcon>
                                                                        </IA.IASavingPlanElementsInfo>
                                                                        <IA.IASavingPlanInputContainer>
                                                                            <IA.IASavingPlanInputWrapper>
                                                                                <IA.IASavingPlanInputRow>
                                                                                    <IA.IASavingPlanInputLabel hasContractSigned={refund.hasContractSigned} elementAmount={refund.elementAmount} theme={theme}>
                                                                                        Importe *
                                                                                    </IA.IASavingPlanInputLabel>
                                                                                    <IA.IASavingPlanInput type="text" value={refund.amount}
                                                                                        onChange={(event) => updatePlanAmount(refund.planId, event.target.value)}
                                                                                        placeholder="Mínimo 1000 Elements IA"
                                                                                        autoComplete="off"
                                                                                        disabled={!canOperate}
                                                                                        hasContractSigned={refund.hasContractSigned}
                                                                                        elementAmount={refund.elementAmount}
                                                                                        theme={theme}
                                                                                    />
                                                                                </IA.IASavingPlanInputRow>
                                                                                {refund.amount !== "" && parseFloat(refund.amount) < 1000 &&
                                                                                (
                                                                                    <IA.IASavingPlanInputError>
                                                                                        Mínimo 1000 Elements IA
                                                                                    </IA.IASavingPlanInputError>
                                                                                )}
                                                                            </IA.IASavingPlanInputWrapper>
                                                                        </IA.IASavingPlanInputContainer>
                                                                    </IA.IASavingPlanAmountLeft>
                                                                    <IA.IASavingPlanAmountRight>
                                                                        {!refund.hasContractSigned ?
                                                                        (
                                                                            <IA.IASavingPlanSignButton id={`sign-contract-button-${index}`} theme={theme}
                                                                                onClick={() => handleSignContract(refund.planId)}
                                                                                onMouseEnter={() => showTeachingBubble(index)}
                                                                                onMouseLeave={() => hideTeachingBubble(index)}
                                                                            >
                                                                                Firmar Contrato
                                                                            </IA.IASavingPlanSignButton>
                                                                        ) :
                                                                        (
                                                                            <IA.IASavingPlanContractSignedText theme={theme}>
                                                                                ✓ Contrato firmado
                                                                            </IA.IASavingPlanContractSignedText>
                                                                        )}
                                                                    </IA.IASavingPlanAmountRight>
                                                                </IA.IASavingPlanAmountRow>
                                                            </IA.IASavingPlanCard>
                                                        </IA.IASavingPlanContainer>
                                                    );
                                                }) :
                                                (
                                                    <IA.IANoPlansText>
                                                        No hay planes de ahorro disponibles para mostrar y por los que puedas reembolsar los Elements IA.
                                                    </IA.IANoPlansText>
                                                )}
                                                {!processingLoading && savingsPlanRefunds && savingsPlanRefunds.length > 0 && savingsPlanRefunds.map((refund, index) =>
                                                {
                                                    if(!refund.hasContractSigned && showTeachingBubbles[index])
                                                    {
                                                        return(
                                                            <TeachingBubble key={`teaching-bubble-${index}`} target={`#sign-contract-button-${index}`}
                                                                headline="Firma de Contrato Requerida" hasCloseButton={true}
                                                                onDismiss={() => hideTeachingBubble(index)}
                                                            >
                                                                Antes de reembolsar los Elements IA tienes que firmar el contrato de Elements en vigor para poder proceder con la orden de transferencia.
                                                                <br />
                                                                <br />
                                                                Pulsa en el botón para firmar el contrato de Elements.
                                                            </TeachingBubble>
                                                        );
                                                    }
                                                    return null;
                                                })}
                                                {savingsPlanRefunds && savingsPlanRefunds.length > 0 &&
                                                (
                                                    <IA.IAContainerButton>
                                                        {areAllVisibleRefundsReady() && isRefundCodeFilled() && areIBANsAvailable() && !isSignatureShowed && !processingLoading &&
                                                        (
                                                            <IA.IACardButton size="lg" onClick={handleShow}>
                                                                Firmar Reembolsos
                                                            </IA.IACardButton>
                                                        )}
                                                        {(!areAllVisibleRefundsReady() || !isRefundCodeFilled() || !areIBANsAvailable() || isSignatureShowed || processingLoading) &&
                                                        (
                                                            <IA.IADisabledCardButton size="lg">
                                                                Firmar Reembolsos
                                                            </IA.IADisabledCardButton>
                                                        )}
                                                    </IA.IAContainerButton>
                                                )}
                                            </IA.IACardBody>
                                        </IA.IACardContainer>
                                    </IA.IATransferForm>
                                </IA.IATransferMain>
                            )}
                        </React.Fragment>
                    )}
                    {showSignature === true &&
                    (
                        <React.Fragment>
                            <div className="ms-Grid-row">
                                <IA.IASignatureForm>
                                    <SignatureComponent signatures={signatures}
                                        alreadySignedText=" "
                                        submitButtonText="Firmar Reembolso"
                                        cancelButtonText="Volver"
                                        headerTextArea={"Introduce el código que te hemos enviado al teléfono XXXXXX" + signatures[0].phone?.slice(signatures[0].phone.length - 3) + " por SMS para firmar el contrato."}
                                        backButtonText="Volver"
                                        onBackButtonClicked={() => history.push('/ElementsIA')}
                                        onCancelButtonClicked={() => history.push('/ElementsIA')}
                                        requestNewCodeButtonText="Recibir nuevo código"
                                        onNewCodeSended={(signatures: any) =>
                                        {
                                            processExpirationDate(signatures);
                                            setSignatures(signatures);
                                        }}
                                        onSignatureChanged={(signatures: any) =>
                                        {
                                            processExpirationDate(signatures);
                                            setSignatures(signatures);
                                        }}
                                        onSigned={handleSubmit}
                                    />
                                </IA.IASignatureForm>
                            </div>
                        </React.Fragment>
                    )}
                    {modalOKShow === true && <ModalElementsIATransfer setModalShow={setModalOKShow} okModal={true} />}
                    {modalKOShow === true && <ModalElementsIATransfer setModalShow={setModalKOShow} okModal={false} errorMessage={errorMessage} onClose={resetStatesAfterError} />}
                </div>
                {processingLoading === true &&
                (
                    <IA.IAProcessingLoadingText>
                        Comprobando los valores introducidos...
                    </IA.IAProcessingLoadingText>
                )}
                <Modal isOpen={showValidationModal} isBlocking={true} styles={{main: {maxWidth: 600}}}>
                    <IA.IAModalValidationContainer>
                        <IA.IAModalValidationTitle>Validación de Reembolsos</IA.IAModalValidationTitle>
                        <IA.IAModelValidationPreviousText>
                            A continuación se muestran los planes que se van a reembolsar.
                        </IA.IAModelValidationPreviousText>
                        {validationResult &&
                        (
                            <div>
                                {validationResult.generalErrors && validationResult.generalErrors.length > 0 &&
                                (
                                    <IA.IAModalValidationSection>
                                        <IA.IAModalValidationSectionTitleError>Errores Generales:</IA.IAModalValidationSectionTitleError>
                                        <IA.IAModalValidationList>
                                            {validationResult.generalErrors.map((error: string, index: number) =>
                                            (
                                                <IA.IAModalValidationListItem key={index}>{error}</IA.IAModalValidationListItem>
                                            ))}
                                        </IA.IAModalValidationList>
                                    </IA.IAModalValidationSection>
                                )}
                                {validationResult.validPlans && validationResult.validPlans.length > 0 &&
                                (
                                    <IA.IAModalValidationSection>
                                        <IA.IAModalValidationSectionTitleSuccess>
                                            Planes Válidos ({validationResult.validPlans.length}):
                                        </IA.IAModalValidationSectionTitleSuccess>
                                        <IA.IAModalValidationList>
                                            {validationResult.validPlans.map((plan: SavingsPlanRefund, index: number) =>
                                            (
                                                <IA.IAModalValidationListItem key={index}>
                                                    <IA.IAModalValidationPlanName>{plan.planName}</IA.IAModalValidationPlanName> - {plan.amount} Elements IA → {plan.selectedAccount}
                                                </IA.IAModalValidationListItem>
                                            ))}
                                        </IA.IAModalValidationList>
                                    </IA.IAModalValidationSection>
                                )}
                                {validationResult.invalidPlans && validationResult.invalidPlans.length > 0 &&
                                (
                                    <IA.IAModalValidationSection>
                                        <IA.IAModalValidationSectionTitleError>
                                            Planes con Errores ({validationResult.invalidPlans.length}):
                                        </IA.IAModalValidationSectionTitleError>
                                        {validationResult.invalidPlans.map((item: any, index: number) =>
                                        (
                                            <IA.IAModalValidationPlanContainer key={index}>
                                                <IA.IAModalValidationPlanName>{item.plan.planName}</IA.IAModalValidationPlanName>
                                                <IA.IAModalValidationPlanErrorsList>
                                                    {item.errors.map((error: string, errorIndex: number) =>
                                                    (
                                                        <IA.IAModalValidationPlanErrorItem key={errorIndex}>{error}</IA.IAModalValidationPlanErrorItem>
                                                    ))}
                                                </IA.IAModalValidationPlanErrorsList>
                                            </IA.IAModalValidationPlanContainer>
                                        ))}
                                    </IA.IAModalValidationSection>
                                )}
                                <IA.IAModalValidationButtonsContainer>
                                    <DefaultButton onClick={() => 
                                    {
                                        setShowValidationModal(false);
                                        setProcessingLoading(false);
                                    }}>
                                        Cerrar
                                    </DefaultButton>
                                    {validationResult.isValid &&
                                    (
                                        <PrimaryButton onClick={() =>
                                        {
                                            setShowValidationModal(false);
                                            proceedWithRefunds(validationResult.validPlans);
                                        }}>
                                            Firmar Reembolsos
                                        </PrimaryButton>
                                    )}
                                </IA.IAModalValidationButtonsContainer>
                            </div>
                        )}
                    </IA.IAModalValidationContainer>
                </Modal>
            </IA.IATransferMain>
        </DocumentTitle>
    );
};

export default ElementsIATransfer;